export const statusGroups = {
    OPEN: [
        "DRAFT",
        "PROPOSED",
        "APPROVED",
        "WAITAPPROVAL",
        "PROGRAMMED",
        "STARTED",
        "MADE_SAFE",
        "PHYSICALLY_COMPLETED",
        "COMPLETED",
        "BLRQ",
        "IN_DISPUTE"
    ],
    "OPEN - WORK COMPLETE": [
        "DRAFT",
        "PROPOSED",
        "APPROVED",
        "WAITAPPROVAL",
        "PROGRAMMED",
        "STARTED",
        "MADE_SAFE",
        "PHYSICALLY_COMPLETED",
    ],
    CLOSED: ["BLAP", "BILLING_COMPLETE", "FINALISED_NOBILLING"],
    VOID: ["CLOSED_D", "CLOSED_N", "REJECTED", "INCC_ASSIGNED"]
};

export const statuses = {
    DRAFT: "DRFT",
    PROPOSED: "PPSD",
    APPROVED: "APPR",
    REJECTED: "RJTD",
    STARTED: "STRT",
    MADE_SAFE: "MDSF",
    PHYSICALLY_COMPLETED: "PHYS",
    COMPLETED: "COMP",
    PROGRAMMED: "PROG",
    WAITAPPROVAL: "PEND",
    BLRQ: "BLRQ",
    FINALISED_NOBILLING: "FNBL",
    BLAP: "BLAP",
    //IN_DISPUTE: "DISP",
    BILLING_COMPLETE: "BCOM",
    INCC_ASSIGNED: "INCC",
    CLOSED_D: "DUPL",
    CLOSED_N: "CNLD"
};

export function display(key) {
    return statuses[key] || key;
}


// WEBPACK FOOTER //
// ./src/helpers/statuses.js